module.exports = __webpack_public_path__ + "img/4.817a1676.png";